import { useState, useEffect, useRef } from 'react';

import useTranslation from 'hooks/useTranslation';
import styles from './styles.module.scss';

const USER_NOTE_ELEMENT_MAX_HEIGHT = 240;

function NoteCard({
  value,
  handleSubmitChanges,
  handleChangeInput,
  handleDiscardChanges,
}) {
  const [editUserInfoNote, setEditUserInfoNote] = useState(false);
  const userNoteTextareaRef = useRef(null);

  const { getTranslation } = useTranslation('ARCHIVE');
  const { t } = getTranslation();

  const placeholder = t('NOTE_PLACEHOLDER');

  const handleClickUserInfoNoteInput = () => {
    setEditUserInfoNote(true);
  };

  const handleDiscardBtnClick = () => {
    handleDiscardChanges();
    setEditUserInfoNote(false);
  };

  const handleConfirmBtnClick = () => {
    handleSubmitChanges();
    setEditUserInfoNote(false);
  };

  const handleEditBtnClick = () => {
    setEditUserInfoNote(true);
  };

  const handleKeyDown = (e) => {
    if (!e || (e && e.key === 'Enter' && !e.shiftKey)) {
      handleSubmitChanges();
      setEditUserInfoNote(false);
    }
  };

  const renderUserInfoNote = () => {
    if (editUserInfoNote) {
      return (
        <div className={styles.note_input}>
          <textarea
            onKeyDown={(e) => handleKeyDown(e)}
            onChange={handleChangeInput}
            value={value}
            type='text'
            ref={userNoteTextareaRef}
            placeholder={placeholder}
            autoFocus
          />
        </div>
      );
    }

    return (
      <div onClick={handleClickUserInfoNoteInput} className={styles.note_inner}>
        <div className={styles.note_inner__box}>
          <div className={styles.note_inner__box__text}>
            {value || placeholder}
          </div>
        </div>
      </div>
    );
  };

  const renderUserInfoNoteActionIcons = () => {
    if (editUserInfoNote) {
      return (
        <div className={styles.actions}>
          <div
            onClick={handleDiscardBtnClick}
            className={styles.actions__cancel}
            data-tool-tip-top={t('NOTE_DISCARD_TOOLTIP')}
          ></div>
          <div
            onClick={handleConfirmBtnClick}
            className={styles.actions__confirm}
            data-tool-tip-top={t('NOTE_SUBMIT_TOOLTIP')}
          ></div>
        </div>
      );
    }

    return (
      <div className={styles.actions}>
        <div
          onClick={handleEditBtnClick}
          class={styles.actions__edit}
          data-tool-tip-top={t('NOTE_EDIT_TOOLTIP')}
        ></div>
      </div>
    );
  };

  // adjusting usernote textarea focus and height
  useEffect(() => {
    const userNoteElement = userNoteTextareaRef.current;
    const userNoteElementScrollHeight = userNoteElement?.scrollHeight;

    if (!userNoteElement) return;

    // if content height is more than max height
    if (userNoteElementScrollHeight > USER_NOTE_ELEMENT_MAX_HEIGHT) {
      userNoteElement.style.height = `${USER_NOTE_ELEMENT_MAX_HEIGHT}px`;
    } else {
      userNoteElement.style.height = `${userNoteElementScrollHeight}px`;
    }

    // move cursor to the bottom of textarea
    userNoteElement.scrollTop = userNoteElement.scrollHeight;

    if (editUserInfoNote) {
      userNoteElement?.focus();
      userNoteElement.selectionStart = userNoteElement.value.length;
      userNoteElement.selectionEnd = userNoteElement.value.length;
    }
  }, [editUserInfoNote]);

  return (
    <>
      <div className='flex'>
        <h3>{t('USER_INFO_INPUT_DETAILS_TITLE')}</h3>
        {renderUserInfoNoteActionIcons()}
      </div>
      {renderUserInfoNote()}
    </>
  );
}

export default NoteCard;
